module.exports = __webpack_public_path__ + "static/media/VidgoLogoV2.a54bb23e.jpg";